import React, { useEffect } from "react";
import ButtonHoverAnimation from "./button/ButtonHoverAnimation";
import { Link } from "react-router-dom";
import { useAccount, useReadContract } from "wagmi";
import { formatUnits, parseAbi, parseEther } from "viem";
import SvgSpinner from "./svgspinner";
import InventoryBalances from "./inventorybalances";
import { PooledCredits, useNftsForUser } from "./balances";
import BrainTable from "./braintable";
import BrainTokenTable from "./braintokentable";

const brainCA = process.env.REACT_APP_BRAIN_ERC721_CA;

const Inventory = () => {
  const { address } = useAccount();

  const { loading, error, ownedBrains } = useNftsForUser(address);

  return (
    <>
      <ButtonHoverAnimation />
      <main data-barba="container" data-barba-namespace="secondary">
        <div className="min-svh-100 d-flex align-items-center justify-content-center px-3 px-sm-4 px-md-5 mx-xl-4 opacity-load">
          <div className="container w-100">
            <div className="spacer"></div>
            <div className="d-flex justify-content-between mb-4 mt-5">
              <h1 className="text-left">Your Assets</h1>
            </div>
            <InventoryBalances />
            <div className="row">
              <div className="col-xl-12">
                <div className="row g-2 g-xxl-3 mb-4 mt-5">
                  <BrainTable
                    dataLoading={loading}
                    ownedBrains={ownedBrains}
                    error={error}
                  />
                  {/* <BrainTokenTable /> */}
                </div>

                <Link
                  className="underline-on-hover-2 d-flex align-items-center mx-auto mt-4 justify-content-center"
                  to="/"
                >
                  <em>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.4526" cy="12.3848" r="12" fill="#75FBFD" />
                      <path
                        d="M13.7493 15.6265L11.1559 12.3848L13.7493 9.14306"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </em>
                  <span className="ps-2">Go Back</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Inventory;
